<template>
	<b-modal size="md" :title="title" ref="requestModal" modal-footer>
		<trade-form v-if="type === 'trade'" :requestInfo="request"/>
		<withdrawal-form v-if="type === 'withdrawal'" :request-info="request" />
		<template v-slot:modal-footer>
			<div></div>
		</template>
	</b-modal>
</template>

<script>
import TradeForm from "./form/TradeForm";
import WithdrawalForm from "./form/WithdrawalForm";

export default {
	name: "Request",
	components: {
		TradeForm,
		WithdrawalForm
	},
	methods: {
		show() {
			this.$refs.requestModal.show();
			this.reloadData();
		},
		hide() {
			this.$refs.requestModal.hide();
		},
		reloadData() {
			if(this.sfaInstruction) {
				this.request = this.sfaInstruction;
				// this.$store.commit('instructions/setSfaInstruction', {});
			} else {
				this.request = this.requestInfo;
			}
		},
	},
	data() {
		return {
			request: {},
		};
	},
	computed: {
		title() {
			if (this.type === "trade") {
				return "Pokyn na nákup/predaj aktíva";
			} else {
				return "Pokyn na výber/vklad peňažných prostriedkov";
			}
		},
		sfaInstruction() {
			return this.$store.state.instructions.sfaInstruction;
		},
	},
	props: {
		type: {
			type: String
		},
		requestInfo: {
			type: Object
		}
	}
};
</script>

<style lang="scss">
.request-wrapper {
	font-size: 13px;

	> div .row {
		margin-top: 15px;

		> div:first-child {
			color: #9a9a9a;
		}
	}

	input[type="radio"] {
		margin-right: 10px;
	}

	select {
		cursor: pointer;
	}

	.btn-group-toggle {
		width: 100%;

		.btn-outline-warning:not(.active):not(:hover) {
			color: white;
			background-color: $medium-gray;
			border-color: $medium-gray;
		}
	}
}

@include media-breakpoint-down(md) {
	.modal {
		padding-left: 2.5vw !important;

		.modal-dialog {
			margin-left: 0 !important;

			.modal-content {
				width: 95vw;
				padding-left: 15px !important;
				padding-right: 15px !important;
			}
		}
	}
}
</style>
